<form (submit)="searchNumber()">
  <div
    class="inner-checking-section text-center visual-builder-block with-border-spacing"
    [class.selected]="selectedId?.id === 'background'"
    #innerCheckingSection
  >
    <div class="container container-min" #container>
      <div class="company">
        <div
          class="company-form mt-0"
          #companyForm
          *ngIf="!noNumbers; else noNumber"
        >
          <p
            *ngIf="searchTitle.length > 0"
            class="company-form-tn visual-builder-block"
            [style.font-size.px]="
                trackingPage?.searchPageTitle?.fontSize || 18
              "
            [ngStyle]="trackingPage?.searchPageTitle | fontFamily"
            [class.selected]="
                selectedId?.id?.includes('searchPageTitle')
              "
            (click)="selectBlock.emit('searchPageTitle')"
          >
            {{ 'search_title' | translate }}
          </p>
          <div
            class="form-group visual-builder-block with-wrapper-block"
            [class.selected]="
                selectedId?.id?.includes('searchPageInput')
              "
          >
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                autocorrect="off"
                autocapitalize="none"
                [formControl]="search"
                (click)="selectBlock.emit('searchPageInput')"
                [ngStyle]="
                    trackingPage?.searchPageInput
                      | fontFamily
                      | assign: searchPageInputStyles
                  "
                [placeholder]="searchInputPlaceholder | translate"
              />
            </div>
          </div>
          <div class="container">
            <div class="row justify-content-center" #row>
              <div
                class="col-md-6 text-center"
              >
                <div *ngIf="!isVisualBuilder; else trackButton">
                  <button
                    class="btn btn-default btn-orange input-group-text search-page-btn visual-builder-block"
                    [class.selected]="
                        selectedId?.id?.includes('trackButton')
                      "
                    type="button"
                    (click)="searchNumber()"
                    [ngStyle]="
                        trackingPage?.trackButton
                          | fontFamily
                          | assign: trackButtonStyles
                      "
                  >
                      <span class="visual-builder-block">
                        {{ 'track_button' | translate }}
                      </span>
                  </button>
                </div>
                <ng-template #trackButton>
                  <div class="flex justify-content-center">
                    <button
                      class="btn btn-default btn-orange input-group-text search-page-btn visual-builder-block"
                      [class.selected]="
                          selectedId?.id?.includes('trackButton')
                        "
                      type="button"
                      (click)="selectBlock.emit('trackButton')"
                      [ngStyle]="
                          trackingPage?.trackButton
                            | fontFamily
                            | assign: trackButtonStyles
                        "
                    >
                        <span
                          class="visual-builder-block"
                          (click)="searchNumber()"
                        >
                          {{ 'track_button' | translate }}
                        </span>
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noNumber>
          <div class="company-form">
            <p
              class="company-form-tn visual-builder-block"
              [style.font-size.px]="
                  trackingPage?.searchPageTitle?.fontSize || 18
                "
              [ngStyle]="trackingPage?.searchPageTitle | fontFamily"
              [class.selected]="
                  selectedId?.id?.includes('searchPageTitle')
                "
              (click)="selectBlock.emit('searchPageTitle')"
              [innerHTML]="
                  noNumbers === true ? ('no_numbers' | translate) : noNumbers
                "
            ></p>
          </div>
          <div class="container">
            <div class="row justify-content-center">
              <div
                class="col-md-6 text-center"
              >
                <div
                  *ngIf="!isVisualBuilder; else visualBuilderButton"
                >
                  <button
                    class="btn btn-default btn-orange input-group-text search-page-btn visual-builder-block"
                    [class.selected]="
                        selectedId?.id?.includes('trackButton')
                      "
                    type="button"
                    (click)="backToSearch()"
                    [ngStyle]="
                        trackingPage?.trackButton
                          | fontFamily
                          | assign: trackButtonStyles
                      "
                  >
                      <span class="visual-builder-block">
                        {{ 'back_to_search_button' | translate }}
                      </span>
                  </button>
                </div>
                <ng-template #visualBuilderButton>
                  <div class="flex justify-content-center">
                    <button
                      class="btn btn-default btn-orange input-group-text search-page-btn visual-builder-block"
                      [class.selected]="
                          selectedId?.id?.includes('trackButton')
                        "
                      type="button"
                      (click)="selectBlock.emit('trackButton')"
                      [ngStyle]="
                          trackingPage?.trackButton
                            | fontFamily
                            | assign: trackButtonStyles
                        "
                    >
                        <span
                          class="visual-builder-block"
                          (click)="backToSearch()"
                        >
                          {{ 'back_to_search_button' | translate }}
                        </span>
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <!-- /container -->
  </div>
  <!-- /inner-checking-section -->
</form>
